import { RiPushpin2Fill, RiMegaphoneFill } from '@remixicon/react';
import { useTheme } from '@material-ui/core/styles';
import { COLORS } from '@internal/backstage-plugin-hm-common';
import { Card } from '../../core/card';
import { AnnouncementCardProps, CardType, CardVariant } from '../../lib/types';

const formatDate = (dateString: string) => {
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    return date.toISOString().split('T')[0];
  } catch {
    return '';
  }
};

export const AnnouncementCard = (props: AnnouncementCardProps) => {
  const theme = useTheme();
  const isDarkTheme = theme.palette.type === 'dark';
  const { actionRoute, announcement } = props;

  const colorVariations = [
    {
      border: COLORS.TOMATO_9,
      background: isDarkTheme ? COLORS.ORANGE_3 : COLORS.ORANGE_13,
    },
    {
      border: COLORS.CYAN_8,
      background: isDarkTheme ? COLORS.CYAN_2 : COLORS.CYAN_13,
    },
    {
      border: COLORS.GRASS_8,
      background: isDarkTheme ? COLORS.GRASS_3 : COLORS.GRASS_13,
    },
    {
      border: COLORS.CRIMSON_8,
      background: isDarkTheme ? COLORS.CRIMSON_2 : COLORS.RED_13,
    },
  ];
  const colorVariation = colorVariations[(announcement.id ?? 0) % 4];

  const announcementCreatedFormatted = announcement.created
    ? formatDate(announcement.created)
    : '';

  const cardProps = {
    ...props,
    type: CardType.announcement,
    variant: props.variant ?? CardVariant.minimal,
    title: announcement.title,
    maxTitleLength: 58,
    created: announcementCreatedFormatted,
    actionRoute: actionRoute ?? `/qeta/articles/${announcement.id}`,
    actionable: true,
    Icon: announcement.tags?.includes('pinned')
      ? RiPushpin2Fill
      : RiMegaphoneFill,
    styles: announcement.tags?.includes('pinned')
      ? {
          card: {
            border: `2px solid ${colorVariation.border}`,
            backgroundColor: colorVariation.background,
          },
          title: { fontSize: '1rem' },
          icon: {
            color: colorVariation.border,
            opacity: 0.5,
          },
        }
      : {
          card: {
            border: `2px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
          },
          title: { fontSize: '1rem' },
          icon: {
            color: theme.palette.textSubtle,
            opacity: 0.5,
          },
        },
  };

  return (
    <Card.Root {...cardProps}>
      <Card.Card>
        <Card.Actionable
          cardProps={cardProps}
          style={{ padding: theme.spacing(0, 0, 1) }}
        >
          <Card.Title />
        </Card.Actionable>
      </Card.Card>
    </Card.Root>
  );
};
